import React, { useEffect, useState } from "react";

import Svg from "../../assets/icons/icon";
import { ModuleCards, Grid, Section, Typography, Loading } from "../../core";
import { updateCurrentPath } from "../../redux/Action/pageRoot";
import { getDashboardStats } from "../../helper/utils/api/dashboard";
import { getCompanyId } from "../../helper/utils/companyId";

import { useDispatch } from "react-redux";

const BuyerDate = [
  {
    tittle: "Add Buyer",
    route: "/addBuyer",
    svg: "addBuyer",
    svgWidth: 22.86,
    svgHeight: 22.86,
  },
  {
    tittle: "Buyer List",
    route: "/buyer-list",
    svg: "buyerList",
    svgWidth: 22.86,
    svgHeight: 22.86,
  },
  {
    tittle: "Transaction History",
    route: "/transactions",
    svg: "transactionHistory",
    svgWidth: 22.86,
    svgHeight: 19.47,
  },
];
const ContractData = [
  {
    tittle: "Add Contract",
    route: "/add-contract",
    svg: "addContract",
    svgWidth: 17.87,
    svgHeight: 27.14,
  },
  {
    tittle: "Contract List",
    route: "/contract-list",
    svg: "buyerList",
    svgWidth: 22.86,
    svgHeight: 22.86,
  },
  {
    tittle: "Yarn History",
    route: "/yarn-history",
    svg: "yarn",
    svgWidth: 22.86,
    svgHeight: 22.86,
  },
  {
    tittle: "Dispatch History",
    route: "/dispatch-list",
    svg: "dispatch",
    svgWidth: 30,
    svgHeight: 30,
  },
  {
    tittle: "Return History",
    route: "/return-history",
    svg: "return",
    svgWidth: 31.43,
    svgHeight: 31.42,
  },
  {
    tittle: "Sale Register",
    route: "/sale-register",
    svg: "buyerList",
    svgWidth: 22.86,
    svgHeight: 22.86,
  },
];
// const SizerData = [
//   {
//     tittle: "Add Sizer",
//     route: "/add-sizer",
//     svg: "addBuyer",
//     svgWidth: 22.86,
//     svgHeight: 22.86,
//   },
//   {
//     tittle: "Sizers List",
//     route: "/sizer-list",
//     svg: "buyerList",
//     svgWidth: 22.86,
//     svgHeight: 22.86,
//   },
//   {
//     tittle: "History",
//     route: "/sizer-dashboard",
//     svg: "transactionHistory",
//     svgWidth: 22.86,
//     svgHeight: 19.47,
//   },
//   {
//     tittle: "Send Yarn",
//     route: "/send-yarn",
//     svg: "sendyarn",
//     svgWidth: 30,
//     svgHeight: 30,
//   },
//   {
//     tittle: "Add Program",
//     route: "/add-program",
//     svg: "addProgram",
//     svgWidth: 24.29,
//     svgHeight: 24.29,
//   },
//   {
//     tittle: "Generate Bill",
//     route: "/pay-now",
//     svg: "generateBill",
//     svgWidth: 20,
//     svgHeight: 19.88,
//   },
// ];
const SettingData = [
  {
    tittle: "General",
    route: "/general",
    svg: "generalSetting",
    svgWidth: 24.86,
    svgHeight: 24.86,
  },
  // {
  //   tittle: "Manage Roles",
  //   route: "/manage-roles",
  //   svg: "manageRole",
  //   svgWidth: 29.39,
  //   svgHeight: 24.71,
  // },
  // {
  //   tittle: "Add users",
  //   route: "add-user",
  //   svg: "transactionHistory",
  //   svgWidth: 31.43,
  //   svgHeight: 31.42,
  // },
  {
    tittle: "Add yarn quality",
    route: "/add-yarn-quality",
    svg: "yarnQuality",
    svgWidth: 21.21,
    svgHeight: 28.57,
  },
  {
    tittle: "Add Cloth quality",
    route: "/add-cloth-quality",
    svg: "clothQuality",
    svgWidth: 21.21,
    svgHeight: 28.57,
  },
  {
    tittle: "Add Tax Rate",
    route: "add-tax-rate",
    svg: "transactionHistory",
    svgWidth: 31.43,
    svgHeight: 31.42,
  },
];

const OverView = () => {
  const dispatch = useDispatch();
  const [stats, setStats] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    dispatch(updateCurrentPath("Overview"));
  }, [dispatch]);

  useEffect(() => {
    const load = async () => {
      const companyId = getCompanyId();
      if (!companyId) return;
      setIsLoading(true);
      try {
        const { data } = await getDashboardStats(companyId);
        setStats(data?.result || data);
      } catch (error) {
        console.log("dashboard stats error", error);
      }
      setIsLoading(false);
    };
    load();
  }, []);

  return (
    <Grid>
      {isLoading ? <Loading /> : null}
      {stats ? (
        <Section padding="20px" className="mb-20">
          <Typography as="h3" weight="bold" text="Company Summary" />
          <div className="d-flex f-wrap" style={{ gap: 16, marginTop: 12 }}>
            {[
              ["Buyers", stats.buyers],
              ["Contracts", stats.contracts],
              ["Dispatches", stats.dispatches],
              ["Invoices", stats.invoices],
              ["Sizers", stats.sizers],
              ["Programs", stats.programs],
              ["Payments", stats.payments],
            ].map(([label, value]) => (
              <Section key={label} padding="12px 20px" bg="#EFF5FE" radius="10px">
                <Typography as="h6" text={label} />
                <Typography as="h3" weight="bold" text={String(value ?? 0)} />
              </Section>
            ))}
          </div>
        </Section>
      ) : null}
      <ModuleCards
        tittle="Buyer"
        data={BuyerDate}
        icon={<Svg width={16} height={20} color="white" icon="buyer" />}
      />
      <ModuleCards
        tittle="Contract"
        data={ContractData}
        icon={<Svg width={16} height={20} color="white" icon="contract" />}
      />

      <ModuleCards
        tittle="Setting"
        data={SettingData}
        icon={<Svg width={16} height={20} color="white" icon="setting" />}
      />
    </Grid>
  );
};

export default OverView;
